import { applySnapshot, types } from 'mobx-state-tree';
import axios from "axios"

import get from 'lodash/get';

import CompanyService from '../services/CompanyService';
import AttendService from '../services/AttendService';
import { Company } from './Company';

import { rootStore } from '.';
import { getDistanceBetweenCoords, isLocationInKorean } from '../lib/Util';
import { isMobileDevice } from '../helpers/helpers';
import isEmpty from 'lodash/isEmpty';


const WorkplaceLocation = types.model({
    name: types.string,
    address: types.string,
    id: types.number,
    radius: types.number,
    gps: types.model({
        latitude: types.number,
        longitude: types.number,
    }),
    distance: types.number,
    isGrpDefaultWp: types.boolean
});

export const Attend = types
    .model('Attend', {
        status: types.optional(types.number, 1),
        daprtment: types.optional(types.string, ''),
        workName: types.optional(types.string, ''),
        todayWorkTimes: types.optional(types.string, ''),
        lastStartWorkTime: types.optional(types.string, ''),
        mainButtonBoolean: types.optional(types.boolean, true),
        // mainButtonColors: types.optional(types.array(types.string), [colors.primary, colors.primaryDark]),
        mainButtonTitle: types.optional(types.string, '출근'),
        mainButtonSubBoolean: types.optional(types.boolean, true),
        mainButtonSubTitle: types.optional(types.string, '출근 전'),
        // mainButtonSubColor: types.optional(types.string, colors.primaryDark),
        mainButtonWorkTime: types.optional(types.string, ''),
        mainButtonTempWorkTime: types.optional(types.string, ''),
        // mainButtonWorkTimeColor: types.optional(types.string, colors.white),
        // startTime: types.optional(types.string, ''),
        // endTime: types.optional(types.string, ''),
        subButtonStatus: types.optional(types.string, 'S'),
        subButtonText: types.optional(types.string, '-'),
        subButtonBgColor: types.optional(types.string, ''),
        // subButtonColor: types.optional(types.string, colors.white),
        subButtonIcon: types.optional(types.string, 'ri-play-fill'),
        datas: types.frozen(),
        gps: types.optional(types.boolean, false),
        permission: types.optional(types.boolean, false),
        userLocation: types.frozen({
            coords: {
                accuracy: 5,
                altitude: 0,
                altitudeAccuracy: 0.5,
                heading: 0,
                latitude: undefined,
                longitude: undefined,
                speed: 0,
            },
            mocked: false,
            provider: 'fused',
            timestamp: 1664168250178,
        }),
        areas: types.optional(types.array(types.frozen()), []),
        locationList: types.optional(types.array(WorkplaceLocation), []),
        isPerMissionGranted: types.optional(types.boolean, false),
        isAuthorizedIp: types.optional(types.boolean, false),
        publicOutIp: types.optional(types.string, ''),
    })
    .views((self) => ({
        get get() {
            try {
                return { ...self };
            } catch (err) {
                console.error(err);
                return err;
            }
        },
    }))
    .actions((self) => ({
        reset() {
            console.log('RESET MOBX MODEL')
            applySnapshot(self, {});
        },
        setAreas(value) {
            self.areas = value;
        },
        async getAreas() {
            try {
                const response = await CompanyService.getWorkingArea(Company.id);
                self.setAreas(response?.data || []);
            } catch (err) {
                console.error('Error fetching areas:', err);
            }
        },
        getUserLocation(updateLocation) {
            // Use Permissions API if available
            if (navigator.permissions && navigator.permissions.query) {
                navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
                    if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
                        // Try to get current position
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                self.setUserLocation({
                                    coords: {
                                        latitude: position.coords.latitude,
                                        longitude: position.coords.longitude,
                                        accuracy: position.coords.accuracy,
                                        altitude: position.coords.altitude || 0,
                                        altitudeAccuracy: position.coords.altitudeAccuracy || 0.5,
                                        heading: position.coords.heading || 0,
                                        speed: position.coords.speed || 0,
                                    },
                                    mocked: false,
                                    provider: 'web',
                                    timestamp: position.timestamp,
                                });
                                self.setPermission(true);
                                self.setLocationListWithDistance();
                                self.checkUserWithinWorkplaceRadius();
                                self.setPerMissionGranted(true);

                                isLocationInKorean(position.coords.latitude, position.coords.longitude, (status) => {
                                    self.setIsUserInKorean(status);
                                });
                                updateLocation && updateLocation({
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude
                                });
                                return position;
                            },
                            (error) => {
                                console.error('Geolocation error:', error.message);
                                self.setPermission(false);
                                self.setPerMissionGranted(false);
                            },
                            { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
                        );
                    } else {
                        console.error('Geolocation is not supported by this browser.');
                        self.setUserLocation({
                            coords: {},
                            mocked: false,
                            provider: 'web',
                            timestamp: undefined,
                        });
                        self.setPermission(false);
                        self.setPerMissionGranted(false);
                        isLocationInKorean(undefined, undefined, (status) => {
                            self.setIsUserInKorean(status);
                        });
                        self.setLocationListWithDistance();
                        self.checkUserWithinWorkplaceRadius();
                        return;
                    }
                });
            }
        },
        setIsUserInKorean(value) {
            self.isUserInKorean = value;
        },
        setUserLocation(value) {
            self.userLocation = value;
        },
        setPermission(value) {
            self.permission = value;
        },
        setLastStartWorkTime(value) {
            self.lastStartWorkTime = value;
        },
        setTodayWorkTimes(value) {
            self.todayWorkTimes = value;
        },
        setMainButtonTempWorkTime(value) {
            self.mainButtonTempWorkTime = value;
        },
        setMainButtonWorkTime(value) {
            self.mainButtonWorkTime = value;
        },
        setWorkName(value) {
            self.workName = value;
        },
        setWorkTime(value) {
            self.mainButtonWorkTime = value;
        },
        setGps(value) {
            self.gps = value;
        },
        setStartTime(value) {
            self.startTime = value;
        },
        setEndTime(value) {
            self.endTime = value;
        },
        setCompanyInfo(value) {
            self.workName = value.workName;
            self.workType = value.workType;
            self.todayWorkTimes = value.todayWorkTimes;
        },
        setMainButtonBoolean(value) {
            self.mainButtonBoolean = value;
        },
        setType(value) {
            self.startTime = value.startTime;
            self.endTime = value.endTime;
            self.mainButtonTitle = value.mainButtonTitle;
            self.mainButtonSubTitle = value.mainButtonSubTitle;
            self.mainButtonWorkTime = value.mainButtonWorkTime;
            self.mainButtonBoolean = value.mainButtonBoolean;
            self.mainButtonSubBoolean = value.mainButtonSubBoolean;
            self.mainButtonWorkTimeColor = value.mainButtonWorkTimeColor;
            self.mainButtonColors = value.mainButtonColors;
            self.subButtonStatus = value.subButtonStatus;
            self.subButtonText = value.subButtonText;
            self.subButtonBgColor = value.subButtonBgColor;
            self.subButtonColor = value.subButtonColor;
            self.subButtonIcon = value.subButtonIcon;
        },
        setStatus(value) {
            self.status = value;
        },
        setAttendData(value) {
            self.datas = value;
        },
        setPublicIp(value) {
            self.publicOutIp = value;
        },
        setLocationList(locations) {
            if (!locations.length) {
                return;
            }

            self.locationList = locations;
            self.setLocationListWithDistance(true);
        },
        setLocationListWithDistance(isInitWorkplace) {
            const locationWithDistance = self.locationList.map(location => {
                const distance = getDistanceBetweenCoords(
                    location.gps.latitude,
                    location.gps.longitude,
                    self.userLocation.coords.latitude,
                    self.userLocation.coords.longitude
                );
                return { ...location, distance };
            });
            const sortedLocations = locationWithDistance.sort(
                (a, b) => parseFloat(a.distance) - parseFloat(b.distance)
            );

            self.locationListWithDistance = sortedLocations;

            if (isInitWorkplace || isEmpty(self.selectedWorkplace)) {
                const defaultWorkplace = sortedLocations.filter(i => i.isGrpDefaultWp);
                self.setSelectedWorkplace(defaultWorkplace[0]);
            } else if (!isEmpty(self.selectedWorkplace)) {
                const selectedWorkplace = sortedLocations.filter(i => i.id === self.selectedWorkplace?.id);
                if (selectedWorkplace.length) {
                    self.setSelectedWorkplace(selectedWorkplace[0]);
                }
            }
        },
        setSelectedWorkplace(location) {
            self.selectedWorkplace = location;
            if (!isEmpty(location)) {
                self.gpsCheck();
            }
        },
        setIsUserWithinWorkplace(value) {
            self.isUserWithinWorkplace = value;
        },
        setIsClockedIn(startTime) {
            self.isClockedIn = !!startTime;
        },
        setIsClockedOut(startTime, endTime, endTime2) {
            self.isClockedOut = !!startTime && !!endTime && !!endTime2;
        },
        setIsTimeRestarting(value) {
            self.isTimeRestarting = value;
        },
        setPerMissionGranted(value) {
            self.isPerMissionGranted = value;
        },
        setIsAuthorizedIp(value) {
            self.isAuthorizedIp = value;
        },
        getIsTimeRestarting() {
            return self.isTimeRestarting;
        },
        getIsStartTimeRestarting() {
            const { startTime, endTime, endTime2 } = get(self, 'datas.info', {});

            return self.isTimeRestarting && startTime && endTime && endTime2;
        },
        getIsEndTimeRestarting() {
            const { startTime, endTime, endTime2 } = get(self, 'datas.info', {});
            return startTime && endTime && !endTime2;
        },

        async setData(_compId, _userId) {
            try {
                const companyId = _compId || rootStore.company.get.id;
                const userId = _userId || rootStore.user.me.id
                const res = await AttendService.attendTodayInfo(companyId, userId);
                if (!res?.data) return; // TODO: handle errors
                if (res.data === 'securityDevice') {
                    self.setStatus(99999);
                } else {
                    self.setAttendData(res.data);
                    self.setStatus(res.data?.info?.status || 1);
                    // self.setMainButtonWorkTime(res.data.info.mainButtonWorkTime);
                    self.setWorkName(res.data?.info?.workName);
                    self.setAreas(res.data?.info?.areas || []);
                    if (res.data.info.workStartTime && res.data.info.workEndTime) {
                        self.setTodayWorkTimes(`${res.data.info.workStartTime} ~ ${res.data.info.workEndTime}`);
                    }

                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        },
        async getAttendTodayInfo() {
            try {
                const companyId = rootStore.company.get.id;
                const userId = rootStore.user.me.id;
                const res = await AttendService.attendTodayInfo(companyId, userId);

                if (!res?.data) return;
                if (res.data === 'securityDevice') {
                    self.setStatus(99999);
                } else {
                    self.setAttendData(res.data);
                    self.setStatus(res.data.info.status);
                    self.setWorkName(res.data?.info?.workName);
                    self.setAreas(res.data?.info?.areas || []);
                    self.setIsClockedIn(res?.data?.info?.startTime2);
                    self.setIsClockedOut(
                        res?.data?.info?.startTime2,
                        res?.data?.info?.endTime,
                        res?.data?.info?.endTime2
                    );
                    // if(res?.data?.info?.startTime && res?.data?.info?.endTime) {
                    // 	const mainButtonWorkTime = (moment(attendStore.get.datas.info.endTime).valueOf() / 1000) - (moment(attendStore.get.datas.info.startTime).valueOf() / 1000);
                    // 	self.setMainButtonWorkTime(mainButtonWorkTime);
                    // }
                    return res?.data;
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        },
        async reflashData(_compId, _userId) {
            try {
                const companyId = _compId || rootStore.company.get.id;
                const userId = _userId || rootStore.user.me.id;
                const res = await AttendService.attendTodayInfo(companyId, userId);
                if (!res?.data) return; // TODO: handle errors
                if (res.data === 'securityDevice') {
                    self.setStatus(99999);
                } else {
                    // self.setStatus(res.data.info.status);
                    self.setWorkName(res.data?.info?.workName);
                    if (res.data.info.workStartTime && res.data.info.workEndTime) {
                        self.setTodayWorkTimes(`${res.data.info.workStartTime} ~ ${res.data.info.workEndTime}`);
                    }
                }
            } catch (err) {
                console.error('Error refreshing data:', err);
            }
        },
        async requestAttend(params, cbAfterRequest) {
            const { type, showNotification, t } = params;
            let res = {};
            try {
                const companyId = rootStore.company.get.id;
                const userId = rootStore.user.me.id;
                const locationInfo = rootStore.company.get.locationInfo || 'USER_LOCATION';
                const { id } = get(self, 'datas.info.area', '');
                const { group } = get(self, 'datas', '');
                const { latitude: lat, longitude: lng } = get(self, 'userLocation.coords', {});
                const workplaceGps = get(self, 'selectedWorkplace', {});
                const { startTime, endTime, endTime2 } = get(self, 'datas.info', {});
                const checkingStatus = get(self, 'datas.info.status', 1);
                const now = new Date();

                let workType = '';
                if (checkingStatus === 4) { // Already clocked out => override startTime
                    workType = endTime2 === null ? 'E' : 'S'; // Already clocked in after restarting => override endTime
                } else { // new date time
                    workType = startTime ? 'E' : 'S';
                }

                res = await AttendService.gpsRequestAttend({
                    companyId,
                    userId,
                    areaId: id,
                    restdayName: '근무',
                    groupId: group?.id,
                    workType,
                    attendType: 'GPS',
                    lat: isMobileDevice() ? locationInfo === 'WORK_LOCATION' ? workplaceGps?.gps?.latitude : lat : lat,
                    lng: isMobileDevice() ? locationInfo === 'WORK_LOCATION' ? workplaceGps?.gps?.longitude : lng : lng,
                    realTime: type === 'restart' ? '' : now,
                    thisTime: type === 'restart' ? '' : now,
                    locationInfo
                });

                const showError = get(res, 'data[0].showError', false);
                const message = get(res, 'data[0].message', '');

                if (res.code === 200 && !showError) {
                    await self.getAttendTodayInfo();
                    self.setIsTimeRestarting(false);
                    cbAfterRequest?.();
                } else {
                    if (showError) {
                        showNotification(t('common.label.alert'), message, 'warning');
                    } else {
                        showNotification(t('common.label.alert'), res.code, 'warning');
                    }
                }
                if (!res?.data) return;
                return res?.data;
            } catch (err) {
                showNotification(t('common.label.alert'), res.code, 'warning');
            }
        },

        async getLocationList(callback) {
            try {
                const companyId = get(rootStore, 'company.id');
                const userId = get(rootStore, 'user.me.id');
                const res = await CompanyService.getWorkingArea(
                    companyId, userId, true, isMobileDevice()
                );

                self.setLocationList(res?.data);
                callback && callback(res?.data);
                return res?.data;
            } catch (error) {
                console.error(error);
            }
        },

        async getPublicIp() {
            try {
                const res = await axios.get('https://api.ipify.org/?format=json');

                self.setPublicIp(res?.data?.ip);
                return res?.data?.IPv4;
            } catch (error) {
                self.setPublicIp('');
            }
        },

        async gpsCheck() {
            const { latitude: lat, longitude: lng } = get(self, 'userLocation.coords', {});
            const companyId = rootStore.company.get.id;
            const { id = '', radius = '' } = self.selectedWorkplace || {};
            if (!lat || !lng || !id) return;
            try {
                const res = await CompanyService.gpsCheck({
                    areaId: id,
                    companyId,
                    lat,
                    lng,
                    radius,
                    wifi: self.publicOutIp,
                });

            } catch (error) {

            }
        },
        checkUserWithinWorkplaceRadius() {
            try {
                if (!window.kakao?.maps) {
                    return;
                }

                const { latitude: userLat, longitude: userLng } = get(self, 'userLocation.coords', {});
                if (!userLat || !userLng) {
                    // 사용자 위치를 못 구한 상태라면 return 반환
                    return;
                }

                const locationListWithDistance = get(self, 'locationListWithDistance', []);
                if (!locationListWithDistance.length) {
                    // 소속된 근무지가 하나도 없으면 판정할 대상이 없으므로 return
                    return;
                }

                // 소속된 근무지 중 반경 안에 들어온 근무지를 전부 찾는다 (여러 근무지 중 하나라도 반경 안이면 출퇴근 가능)
                const matchedWorkplaces = locationListWithDistance.filter((workplace) => {
                    const { radius } = workplace || {};
                    const { latitude: workplaceLat, longitude: workplaceLng } = workplace?.gps || {};

                    // radius/gps 좌표가 없는 비정상 데이터는 매칭 대상에서 제외
                    if (!radius || !workplaceLat || !workplaceLng) {
                        return false;
                    }

                    const distance = getDistanceBetweenCoords(userLat, userLng, workplaceLat, workplaceLng, 'm');
                    return distance <= radius;
                });

                // 반경 안에 든 근무지가 하나도 없으면 기본근무지(isGrpDefaultWp)로 되돌아간다.
                const nextWorkplace = matchedWorkplaces.length
                                    ? matchedWorkplaces[0]
                                    : locationListWithDistance.find(i => i.isGrpDefaultWp);

                // 활성 근무지가 실제로 바뀔 때만 갱신
                if (nextWorkplace && nextWorkplace.id !== self.selectedWorkplace?.id) {
                    self.setSelectedWorkplace(nextWorkplace);
                }

                // 출퇴근타각 가능 여부는 소속 근무지 중 하나라도 반경 안인지 판정함
                self.setIsUserWithinWorkplace(matchedWorkplaces.length > 0);
            } catch (error) {
            }
        },
        async checkGoToWork() {
            try {
                if (!isMobileDevice()) {
                    return false;
                }
                const showCheckingWorkPopup = localStorage.getItem('showAttendancePopup');

                if (showCheckingWorkPopup === null) {
                    const companyId = get(rootStore, 'company.id');
                    const userId = get(rootStore, 'user.me.id');
                    const res = await AttendService.go2WorkCheck({
                        companyId,
                        userId
                    });

                    localStorage.setItem('showAttendancePopup', res.result);
                    return res.result;

                } else {
                    return false;
                }
            } catch (error) {
                console.error(error)
            }

        },
        checkGeolocationPermission() {
            if (!('permissions' in navigator)) {
                console.warn('Browser does not support navigator.permissions');
                return;
            }

            navigator.permissions.query({ name: 'geolocation' }).then((result) => {
                switch (result.state) {
                    case 'granted':
                        self.setPerMissionGranted(true);
                        break;
                    case 'denied':
                        self.setPerMissionGranted(false);
                        break;
                }
                // Listen for changes in permission state
                result.onchange = () => {
                    self.setPerMissionGranted(result.state === 'granted');
                }
            });
        },
        async checkAuthorizedIp() {
            const companyId = rootStore.company.get.id;
            const ip = self.publicOutIp;
            if (!companyId || !ip) return;
            const res = await AttendService.checkAuthorApi(({ companyId, ip }));
            self.setIsAuthorizedIp(res?.result);
        }

    }));

export default Attend;
